/**
 * Subdomain Detection and Department Routing Utilities
 * Handles multi-tenant subdomain detection and department-specific theming
 */

export const getSubdomainInfo = () => {
  const hostname = window.location.hostname;
  
  // Debug logging
  console.log('🔍 Subdomain Detection Debug:', {
    hostname,
    currentURL: window.location.href
  });
  
  // Check if it's the main domain or development/preview environments
  const isMainDomain = 
    hostname === 'reqtrak.com' || 
    hostname === 'www.reqtrak.com' ||
    hostname.includes('vercel.app') ||
    hostname === 'localhost' ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('emergentagent.com') ||  // Emergent preview URLs
    hostname.includes('preview.') ||           // Any preview environment
    hostname.includes('foi-manager');          // Current development environment

  // Extract subdomain only if it's actually a department subdomain
  let subdomain = null;
  if (!isMainDomain) {
    const parts = hostname.split('.');
    if (parts.length > 2 && parts[parts.length - 1] === 'com' && parts[parts.length - 2] === 'reqtrak') {
      subdomain = parts[0]; // Only for *.reqtrak.com domains
    }
  }
  
  const result = {
    isMainDomain,
    subdomain,
    hostname,
    isDepartmentPortal: !isMainDomain && subdomain
  };
  
  // Debug logging
  console.log('🎯 Subdomain Detection Result:', result);
  
  return result;
};

export const getDepartmentFromSubdomain = (subdomain) => {
  // Map of known subdomains to department info
  const departmentMap = {
    'shakerpd': {
      id: 'shakerpd',
      name: 'Shaker Heights Police Department',
      subdomain: 'shakerpd',
      logo_url: null, // Will be loaded from backend
      primary_color: '#2563eb',
      secondary_color: '#1e40af',
      theme: 'default'
    }
    // Add more departments as they register
  };

  return departmentMap[subdomain] || null;
};

export const loadDepartmentTheme = (departmentData) => {
  if (!departmentData) return;

  // Apply department-specific CSS variables
  const root = document.documentElement;
  
  if (departmentData.primary_color) {
    root.style.setProperty('--department-primary', departmentData.primary_color);
  }
  
  if (departmentData.secondary_color) {
    root.style.setProperty('--department-secondary', departmentData.secondary_color);
  }
  
  // Update page title
  document.title = `${departmentData.name} | Police Records Portal`;
};

export const shouldShowMarketingPage = () => {
  const { isMainDomain } = getSubdomainInfo();
  return isMainDomain;
};

export const shouldShowDepartmentPortal = () => {
  const { isDepartmentPortal } = getSubdomainInfo();
  return isDepartmentPortal;
};